import { default as ButtonMUI } from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  margin-bottom: 30px;

  label {
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.56);
    display: block;
    margin-bottom: 8px;
  }

  .error {
    color: red;
    font-size: 11px;
  }

  .dropzone {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 5px;
    border-color: #aeaeae;
    border-style: dashed;
    background-color: #fff;
    color: #b8b8b8;
    outline: none;
    transition: border color 0.24s ease-in-out;

    .dropzone-body {
      display: flex;
      flex-direction: column;
      align-items: center;

      svg {
        height: 60px;
        width: 60px;
      }
      p {
        text-align: center;
        margin-bottom: 0;
      }
    }

    &:hover {
      border-color: #8e8e8e;
      color: #979797;
    }

    &:focus,
    &.active {
      border-color: #2196f3;
      color: #2196f3;
    }
    &.rejected {
      border-color: #f32121;
      color: #f32121;
    }
    &.disabled {
      border-color: #d0d0d0;
      color: #cacaca;
    }
  }
`;

/**
 * Estilização do componente Wrap
 */
export const Button = styled(ButtonMUI)`
  &.MuiButton-contained {
    background: #fff;
    color: #000;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.4);
    border-radius: 3px;
    padding: 10px 20px;
    text-transform: uppercase;
    font-size: 11px;
    line-height: 13px;
    margin-top: 17px;

    &:hover {
      background: #ededed !important;
      border: none;
    }
  }
`;
